"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SheetDirections = void 0;
var SheetDirections = {
  Top: 'top',
  Right: 'right',
  Bottom: 'bottom',
  Left: 'left'
};
exports.SheetDirections = SheetDirections;